import React, { useState } from "react";
import { MdAlternateEmail } from "react-icons/md";
import { MdLink } from "react-icons/md";

const AsiaTeamCard = (props) => {
  const { id, name, position, img, about, link, docLink } = props;

  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  const href = link != "" ? link : docLink;

  return (
    <div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center members-card">
      <div className="card">
        <div className="card-header">
          <img className="card-avatar" src={img} alt="avatar" />
          <h2 className="card-fullname">{name}</h2>
          <h2 className="card-jobtitle">{position}</h2>
          {/* <h2 className="card-job-year">{year}</h2> */}
        </div>
        <div className="card-main">
          <div className="card-section is-active">
            <div className="card-content">
              <div className="card-subtitle">About</div>

              <div className="accordion-height">
                <p className="card-desc">
                  {expanded ? about : about.slice(0, 100) + "..."}
                  {about.length > 100 && (
                    <span onClick={toggleExpanded}>
                      {expanded ? "Read less" : "Read more"}
                    </span>
                  )}
                </p>
              </div>

              {/* <label className="read-more" htmlFor={accordionId}>
                {about != '' ? 'Read More' : ''}
                
              </label> */}
            </div>
            <a className="card-social" href={href}>
              {/* <div className="card-social"> */}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-4"
              >
                <MdLink />
              </a>
              <p className="social-link m-0">Click More Details</p>{" "}
              {/* </div> */}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AsiaTeamCard;
function shortenLink(url) {
  try {
    const { hostname } = new URL(url);
    return hostname.replace("www.", ""); // shows only domain
  } catch {
    return url; // fallback if invalid URL
  }
}
